import axios from "axios";

export function fetchDrives(params = {}) {
    return axios.get('/clsystem/api/v1/drive', {params: params})
}

export function fetchZones(params = {}) {
    return axios.get('/geo/api/v1/zone', {params: params})
}